import { PlayerTypes, SET_PLAYER } from '../types';

const playerReducer = (state = 0, action: PlayerTypes) => {
    switch (action.type) {
        case SET_PLAYER:
            state = action.id;
            return state;
        default:
            return state;
    }
};

export default playerReducer;
